module.exports = __webpack_public_path__ + "mintandmustard.png?c4e0902ea0c5ca7535d1d8e2fadb8fc3";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/mintandmustard.png
// module id = 683
// module chunks = 0